module.exports = __webpack_public_path__ + "24b7c218e4f730c59e6e9e99c64b1dfc.pdf";